export interface BuildOrderMapLinkInput {
  readonly latitude: number;
  readonly longitude: number;
}

export interface BuildWhatsAppOrderLocationShareLinkInput extends BuildOrderMapLinkInput {
  readonly intro?: string;
  readonly googleMapsLabel?: string;
  readonly wazeLabel?: string;
}

const LRI = '\u2066';
const PDI = '\u2069';

export function buildGoogleMapsOrderLocationLink({
  latitude,
  longitude,
}: BuildOrderMapLinkInput): string {
  return `https://maps.google.com/?q=${latitude},${longitude}`;
}

export function buildWazeOrderLocationLink({
  latitude,
  longitude,
}: BuildOrderMapLinkInput): string {
  const query = `${latitude},${longitude}`;
  return `https://waze.com/ul?ll=${encodeURIComponent(query)}&navigate=yes`;
}

export function buildOrderLocationShareText({
  intro = 'Delivery location:',
  googleMapsLabel = 'Google Maps',
  wazeLabel = 'Waze',
  ...input
}: BuildWhatsAppOrderLocationShareLinkInput): string {
  const googleMapsLink = buildGoogleMapsOrderLocationLink(input);
  const wazeLink = buildWazeOrderLocationLink(input);
  return [
    intro,
    `${googleMapsLabel}: ${LRI}${googleMapsLink}${PDI}`,
    `${wazeLabel}: ${LRI}${wazeLink}${PDI}`,
  ].join('\n');
}

export function buildWhatsAppOrderLocationShareLink(
  input: BuildWhatsAppOrderLocationShareLinkInput,
): string {
  return `https://wa.me/?text=${encodeURIComponent(buildOrderLocationShareText(input))}`;
}
